const formatCentsPrice = (price: number): string =>
    (parseFloat(String(price).replace(',', '.')) / 100).toFixed(2).replace('.', ',');

export default formatCentsPrice;
